import { config } from '../components/constants.js';
import { clearStoredReferralUsername } from './referralStorage.js';
import { navigateAfterAuth } from './authRedirect.js';
import { setRememberMeEligible } from '../components/infrastructure/authStorage.js';
import {
  isJoinCheckoutIntent,
  runJoinCheckoutAfterAuth,
  formatJoinCheckoutError,
} from '../components/paywall/joinCheckoutFlow.js';

const url = config.url.API_URL;

/**
 * Finish client session setup after a successful /auth/* or /record/googleLogin response.
 */
export async function completeSessionAfterAuth({
  authResponse,
  navigate,
  from,
  intent,
  refreshAccess,
  setUserEmail,
  setIsAuthenticated,
  setUserId,
  getLastSkill,
  findNextLearningOpportunity,
}) {
  if (authResponse?.user?.email) {
    setUserEmail(authResponse.user.email);
  }

  setRememberMeEligible(Boolean(authResponse?.access?.canUseRememberMe));

  const check = await fetch(`${url}/record/checkAuth`, {
    method: 'GET',
    credentials: 'include',
  });
  const checkData = await check.json();

  if (!checkData.authenticated) {
    throw new Error('Session could not be established. Please try again.');
  }

  setIsAuthenticated(true);
  setUserId(checkData.userId);
  clearStoredReferralUsername();

  if (isJoinCheckoutIntent(intent)) {
    try {
      await runJoinCheckoutAfterAuth({
        returnTo: from,
        refreshAccess,
        navigate,
      });
    } catch (error) {
      const checkoutError = new Error(formatJoinCheckoutError(error));
      checkoutError.code = error.code;
      throw checkoutError;
    }
    return;
  }

  await navigateAfterAuth({
    navigate,
    from,
    userId: checkData.userId,
    getLastSkill,
    findNextLearningOpportunity,
    needsTeacherOnboarding: Boolean(
      checkData.needsTeacherOnboarding || authResponse?.needsTeacherOnboarding
    ),
  });
}

export function getUserTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch (error) {
    return 'America/New_York';
  }
}
